import type { FC } from "react";
import { useDispatch } from "react-redux";
import { showModal } from "../../redux/modals/actions";
import type { Modal as ModalType } from "../../redux/modals/modals.types";
import Button from "../button/button";
import * as CSS from "./modals.styles";

type ModalProps = {
	modal: ModalType;
	visible: boolean;
};

const Modal: FC<ModalProps> = ({ modal, visible }) => {
	const dispatch = useDispatch();

	const {
		id,
		title,
		description,
		children,
		onConfirm,
		onCancel,
		hideCancel = false,
		disabled = false,
	} = modal;

	return (
		<CSS.Modal data-testid={`modal-${id}`} $visible={visible}>
			{title && <CSS.Title>{title}</CSS.Title>}
			{description && <CSS.Text>{description}</CSS.Text>}
			{children}
			<CSS.ButtonContainer>
				<Button
					disabled={disabled}
					onClick={() => {
						onConfirm();
						dispatch(showModal(null));
					}}
				>
					Confirm
				</Button>
				{hideCancel === false && (
					<Button
						$variant="secondary"
						onClick={() => {
							if (onCancel) {
								onCancel();
							}

							dispatch(showModal(null));
						}}
					>
						Cancel
					</Button>
				)}
			</CSS.ButtonContainer>
		</CSS.Modal>
	);
};

export default Modal;
